import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import MaintenancePainel from "./MaintenancePainel";

function Maintenance() {
	return (
		<ToastProvider>
			<Dashboard>
				<MaintenancePainel />
			</Dashboard>
			<Toast />
		</ToastProvider>
	)
}

export default Maintenance
